module.exports = __webpack_public_path__ + "img/stepsOne.16b62071.svg";